import * as $ from 'jquery';

/**
 * LoadingAnimationHelper
 *
 * @author Markus Hölzle <m.hoelzle@andersundsehr.com>
 */
export default class LoadingAnimationHelper {

  /**
   * Append the loading animation to the given container
   *
   * @param {jQuery} $container
   */
  appendLoadingAnimation($container) {
    let loadinganimationsvg = $container.parent().attr('data-loadinganimationsvg');
    if (loadinganimationsvg) {
      $container.append('<img class="' + 'js-loading-animation'
        + '" style="margin: auto; width: 100px; display: block;"'
        + ' src="' + loadinganimationsvg + '" />');
    }
  }

  /**
   * Remove the loading animation from the given container
   *
   * @param {jQuery} $container
   */
  removeLoadingAnimation($container) {
    $container.find('.' + 'js-loading-animation').remove();
  }
}
